"use client";

import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { useEffect, useMemo, useState } from "react";
import { CommonCMS } from "@lib/constants/contentful";
import type { ButtonProps } from "@ecco/ui/button";
import { Button } from "@ecco/ui/button";

const AccessibilityToggle = ({ children, ...props }: ButtonProps) => {
    const { getMultiple } = useMicrocopy();
    const [isReady, setIsReady] = useState(false);

    const microcopies = useMemo(() => {
        const shared = getMultiple(CommonCMS.shared, [
            CommonCMS.accessibilityActivate,
            CommonCMS.accessibilityDeactivate,
        ]);
        return {
            activate: shared[CommonCMS.accessibilityActivate],
            deactivate: shared[CommonCMS.accessibilityDeactivate],
        };
    }, [getMultiple]);

    useEffect(() => {
        const btn = document.getElementById("audioeye_activate_btn") as HTMLButtonElement | null;
        if (!btn) return;

        const tryInit = () => {
            const ae = (window as any).AudioEye;
            if (ae?.ClientElementApi?.init) {
                try {
                    ae.ClientElementApi.init();
                } catch {
                    // AudioEye init can throw if already initialized; safe to ignore
                }
                btn.removeAttribute("disabled");
                setIsReady(true);
                return true;
            }
            return false;
        };

        if (tryInit()) return;

        const interval = setInterval(() => {
            if (tryInit()) clearInterval(interval);
        }, 100);

        return () => clearInterval(interval);
    }, []);

    return (
        <Button
            data-ae-cta-opted-in-copy={microcopies.deactivate}
            data-ae-cta-opted-out-copy={microcopies.activate}
            data-ae-cta-optin-button="true"
            id="audioeye_activate_btn"
            type="button"
            disabled={!isReady}
            {...props}
        >
            {children || microcopies.activate}
        </Button>
    );
};
export default AccessibilityToggle;
